import { type ReactNode } from "react";

// Constant
const useLocal = false;
const useBeta = true;
//https://thegreenapiv2.stakealerts.com/api/save_rule/
export const WEB_URL = useLocal
  ? "http://localhost:5173"
  : useBeta
    ? "https://thegreen.stakealerts.com"
    : "https://stakealerts.com";
export const BASE_URL = useLocal
  ? "http://localhost:8000"
  : useBeta
    ? "https://thegreenapiv2.stakealerts.com"
    : "https://apiv2.stakealerts.com";
export const USERNAME = "username";
export const TOKEN = "token";

// App types
export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  avatar?: string;
  emailVerified: boolean;
  isNewUser?: boolean;
  creationTime?: string;
  lastSignInTime?: string;
}

export interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<User>;
  loginWithGoogle: () => Promise<User>;
  loginWithApple: () => Promise<User>;
  register: (
    email: string,
    password: string,
    firstName: string,
  ) => Promise<User>;
  logout: () => Promise<void>;
  resendVerificationEmail: () => Promise<void>;
  refreshUser: () => Promise<void>;
  loading: boolean;
  profileReady: boolean;
}

export interface AuthProviderProps {
  children: ReactNode;
}
